import { Paragraph } from "@tiptap/extension-paragraph";

/**
 * Paragraph that can carry a `label` or `small` preset flag, rendered via the
 * `.lomda-v3-label` (uppercase eyebrow) / `.lomda-v3-small` (14px) classes.
 * Replaces StarterKit's paragraph. The two flags are mutually exclusive — the
 * toolbar clears one when setting the other.
 */
export const LabelParagraph = Paragraph.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            label: {
                default: false,
                // Title-like: Enter at the end gives a Paragraph, like a heading
                // (Small is body text and continues).
                keepOnSplit: false,
                parseHTML: (el) =>
                    (el as HTMLElement).classList.contains("lomda-v3-label"),
                renderHTML: (attrs) =>
                    attrs.label ? { class: "lomda-v3-label" } : {},
            },
            small: {
                default: false,
                parseHTML: (el) =>
                    (el as HTMLElement).classList.contains("lomda-v3-small"),
                renderHTML: (attrs) =>
                    attrs.small ? { class: "lomda-v3-small" } : {},
            },
        };
    },
});
